import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Drawer, Table } from 'antd';
import H3Text from '@Uilib/h3Text';
import H3Image from '@Uilib/h3Image';
import closeIcon from '@Images/icons/icon-close-blue.png';
import { toISTDate } from '@Apis/constants';
import PaymentOutgoingActions from '@Actions/paymentOutgoingActions';
import UserActions from '@Actions/userActions';
import ViewPayment from '@Components/Common/ViewPayment';
import './style.scss';

/**
 *
 */
class OutgoingPayments extends Component {
  /**
   *
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      showViewPayout: false,
      paymentOutgoingColumns: [
        {
          title: 'DATE',
          render: (text, record) => (
            <Fragment>
              <H3Text text={toISTDate(record.payment_date).format('DD/MM/YYYY')} className="org-pending-po__table-created-at" />
            </Fragment>
          ),
        },
        {
          title: 'BUSINESS UNIT',
          render: (text, record) => (
            <Fragment>
              <div
                style={{
                  color: '#2D7DF7', fontWeight: '600', fontSize: '12px', cursor: 'pointer',
                }}
              >
                {record.tenant_info?.tenant_name}
              </div>
            </Fragment>
          ),
        },
        {
          title: 'PAYMENT #',
          render: (text, record) => (
            <H3Text text={record?.payment_id || '-'} className="prod-table__text" />
          ),
        },
        {
          title: 'VENDOR',
          render: (text, record) => {
            const { history } = this.props;
            return (
              <div
                style={{
                  color: '#2D7DF7', fontWeight: '600', fontSize: '12px', cursor: 'pointer',
                }}
                onClick={() => history.push(`/vendors/view/${record?.tenant_seller_info?.seller_id}`)}
              >
                <div
                  style={{
                    color: 'rgb(106, 106, 106)',
                    fontWeight: '600',
                    fontSize: '12px',
                    cursor: 'pointer',
                  }}
                >
                  {record?.seller_info?.internal_slr_code || '-'}

                </div>
                {record?.tenant_seller_info?.seller_name || ' - '}
              </div>
            );
          },
        },
        {
          title: 'AMOUNT',
          render: (text, record) => (
            <H3Text
              text={this.props.MONEY(record?.amount || 0)}
              className="prod-table__text"
            />
          ),
        },
        {
          title: '',
          key: 'action',
          render: (text, record) => (
            <div style={{
              textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center',
            }}
            >
              <div
                className="view-payment__button"
                style={{
                  height: 'auto',
                  padding: '4px 10px',
                  width: '60px',
                }}
                onClick={() => {
                  this.setState({ showViewPayout: true, selectedPayment: record });
                }}
              >
                View
              </div>
            </div>
          ),
        },
      ],
    };
  }

  /**
   *
   * @param props
   * @param state
   * @return {{isUserReady}|*|(*&{isUserReady: boolean})}
   */
  static getDerivedStateFromProps(props, state) {
    if (props.user && !state.isUserReady) {
      const { getPendingActions } = props;
      getPendingActions('map_approved_payments', 10, state.currentPage, () => {});
      return {
        ...state,
        isUserReady: true,
      };
    }
    return state;
  }

  /**
   *
   * @return {JSX.Element}
   */
  render() {
    const {
      tableBorder, getPaymentsOutgoing, user, getApprovedOnlinePayments,
      pendingActions, getPendingActionsLoading, getPendingActions,
    } = this.props;
    const {
      paymentOutgoingColumns, showViewPayout, selectedPayment, currentPage,
    } = this.state;
    return (
      <Fragment>
        <br />
        <Drawer
          open={showViewPayout}
          onClose={() => this.setState({ showViewPayout: false })}
          width="880px"
          destroyOnClose
        >
          <div className="custom-drawer__header-wrapper">
            <div className="custom-drawer__header" style={{ width: '825px' }}>
              <H3Text text={`View Payment #${ selectedPayment?.payment_id}`} className="custom-drawer__title" />
              <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => this.setState({ showViewPayout: false })} />
            </div>
          </div>
          <ViewPayment
            selectedPaymentId={selectedPayment?.payment_id}
            selectPaymentTenant={selectedPayment?.tenant_info?.tenant_id}
            callback={() => {
              this.setState({ showViewPayout: false });
              getPendingActions('map_approved_payments', 10, currentPage, () => {});
            }}
          />
        </Drawer>
        <div className="pending-payments__wrapper hide__in-mobile">
          <Table
            title={() => `${Number(pendingActions?.approved_payments_count)} Approved Payments Pending on Disbursal`}
            bordered={tableBorder}
            loading={getPendingActionsLoading}
            showHeader
            size="small"
            scroll="scroll"
            columns={paymentOutgoingColumns}
            dataSource={pendingActions?.approved_payments || []}
            pagination={Number(pendingActions?.approved_payments_count) > 10 ? {
              defaultCurrent: 1,
              total: Number(pendingActions?.approved_payments_count),
              pageSize: 10,
              position: ['bottomRight'],
              showSizeChanger: false,
              onChange: (page) => {
                this.setState({ currentPage: page });
                getPendingActions('map_approved_payments', 10, page, () => {});
              },
            } : false}
          />
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = ({
  UserReducers, PaymentOutgoingReducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  paymentOutgoing: PaymentOutgoingReducers.paymentOutgoing,
  getPaymentsOutgoingLoading: PaymentOutgoingReducers.getPaymentsOutgoingLoading,
  getPendingActionsLoading: UserReducers.getPendingActionsLoading,
  pendingActions: UserReducers.pendingActions,
});

const mapDispatchToProps = (dispatch) => ({
  getPaymentsOutgoing: (page, limit, tenantId, tenantSellerId, status, tenantRoleId, approvedStatus) => dispatch(PaymentOutgoingActions.getPaymentsOutgoing(page, limit, tenantId, tenantSellerId, status, tenantRoleId, approvedStatus)),
  getApprovedOnlinePayments: (page, limit, tenantId, tenantRoleId) => dispatch(PaymentOutgoingActions.getApprovedOnlinePayments(page, limit, tenantId, tenantRoleId)),
  getPendingActions: (actionType, limit, page, callback) => dispatch(UserActions.getPendingActions(actionType, limit, page, callback)),
});

OutgoingPayments.propTypes = {
  user: PropTypes.any,
  tableBorder: PropTypes.bool,
  getPaymentsOutgoing: PropTypes.any,
  getPaymentsOutgoingLoading: PropTypes.bool,
  paymentOutgoing: PropTypes.any,
  history: PropTypes.any,
  getApprovedOnlinePayments: PropTypes.any,
  getPendingActions: PropTypes.func,
  getPendingActionsLoading: PropTypes.bool,
  pendingActions: PropTypes.any,
  MONEY: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(OutgoingPayments));
